import { StickyNote } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const stop = (e) => { e.preventDefault(); e.stopPropagation(); };

// Wrapper stops the click from reaching the row/link after Radix has toggled the popover.
export const NoteBadge = ({ notes, id }) => notes && (
  <span onClick={stop} className="inline-flex">
  <Popover>
    <PopoverTrigger asChild>
      <button type="button" aria-label={`${notes.count} admin notes`} data-testid={`admin-note-badge-${id}`}
        className="inline-flex h-6 items-center gap-1 rounded-md bg-amber-50 px-1.5 text-xs font-semibold text-amber-800 transition-colors hover:bg-amber-100 dark:bg-amber-500/15 dark:text-amber-300">
        <StickyNote className="h-3.5 w-3.5" />{notes.count}
      </button>
    </PopoverTrigger>
    <PopoverContent className="w-72 text-sm" data-testid={`admin-note-popover-${id}`}>
      <p className="text-xs font-medium text-muted-foreground">{notes.count} note{notes.count === 1 ? "" : "s"} · latest</p>
      <p className="mt-1 whitespace-pre-wrap break-words text-foreground">{notes.last}{notes.last.length >= 140 ? "…" : ""}</p>
    </PopoverContent>
  </Popover>
  </span>
);
